"use client";

import { sentryEnv } from "@/libs/sentry-config";

export default function GlobalError({ error }: { error: Error & { digest?: string } }) {
  if (sentryEnv.enabled) {
    void import("@sentry/nextjs").then((Sentry) => Sentry.captureException(error));
  }
  return (
    <html>
      <body>
        <div className="h-screen w-full flex items-center justify-center p-6 text-center">
          <div>
            <h2 className="text-xl font-semibold">Something went wrong</h2>
            <p className="opacity-70 mt-2">Please refresh the page.</p>
          </div>
        </div>
      </body>
    </html>
  );
}


